var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout layout--blank"},[_c('nuxt'),_vm._v(" "),_c('system-notifications',{attrs:{"notifications":_vm.notifications}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }